<template>
  <div class="popup-manage-contain">
    <section class="popup-manage-search clearfix">
      <div class="search-bar-lf">
        <el-form
          label-position="top"
          :inline="true"
          :model="dataForm"
          width="100%"
          class="search-bar-form"
        >
          <!-- 主题 -->
          <el-form-item :label="$t('pop.themeTitle')" class="search-bar-module">
            <el-input
              v-model="dataForm.title"
              :placeholder="$t('pop.themePlaceHolder')"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 创建人 -->
          <el-form-item :label="$t('pop.creatorTitle')" class="search-bar-module">
            <el-input
              v-model="dataForm.creatByDesc"
              :placeholder="$t('pop.creatorPlaceHolder')"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 创建时间 -->
          <el-form-item :label="$t('pop.createTime')" class="search-bar-module">
            <el-date-picker
              v-model="createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              :start-placeholder="$t('organization.startData')"
              :end-placeholder="$t('organization.endData')"
              :clearable="true"
              :editable="false"
              style="width: 90%"
            ></el-date-picker>
          </el-form-item>
          <!-- 类型 -->
          <el-form-item :label="$t('pop.type')" class="search-bar-module">
            <el-select v-model="dataForm.typeDesc">
              <el-option
                v-for="item in typeList"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 修改人 -->
          <el-form-item :label="$t('pop.editorTitle')" class="search-bar-module">
            <el-input
              v-model="dataForm.publishedByDesc"
              :placeholder="$t('pop.editorPlaceHolder')"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 结束时间 -->
          <el-form-item
            :label="$t('pop.chgTime')"
            class="search-bar-module search-bar-module2"
          >
            <el-date-picker
              v-model="chgTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              :start-placeholder="$t('organization.startData')"
              :end-placeholder="$t('organization.endData')"
              :clearable="true"
              :editable="false"
              style="width: 90%"
            ></el-date-picker>
          </el-form-item>
          <!-- 活动状态 -->
          <el-form-item :label="$t('pop.status')" class="search-bar-module">
            <el-select v-model="dataForm.status" clearable>
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-bar-lr">
        <el-button class="M-search button-margin-b" type="primary" @click="searchList">
          {{ $t("query") }}
        </el-button>
        <el-button class="M-search el-back M-margin-l" type="info" @click="resetList">
          {{ $t("reset") }}
        </el-button>
      </div>
    </section>
    <section class="popup-manage-toolbar">
      <el-button class="popup-manage-add" type="primary" @click="addPop">
        {{ $t("add") }}
      </el-button>
    </section>
    <section class="popup-manage-list">
      <el-table v-loading="dataListLoading" :data="dataList" border style="width: 100%">
        <el-table-column
          type="index"
          :label="$t('pop.no')"
          :index="initIndex"
          width="90"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          v-for="(item, index) in columnList"
          :key="'pop-list' + index"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right" align="center" width="100" :label="$t('handle')">
          <template slot-scope="scope">
            <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                {{ $t("handle") }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="viewDetail(scope.row)">{{
                  $t("view")
                }}</el-dropdown-item>
                <el-dropdown-item
                  @click.native="updatePop(scope.row)"
                  v-if="scope.row.status !== 1"
                  >{{ $t("update") }}</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="delPop(scope.row)"
                  v-if="scope.row.status !== 1"
                  >{{ $t("delete") }}</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="downPop(scope.row)"
                  v-if="scope.row.status === 1"
                  >{{ $t("couse.undercarriage") }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <section class="popup-manage-footer">
      <el-pagination
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dataForm: {
        title: "",
        creatByDesc: "",
        publishedByDesc: "",
        typeDesc: "",
        status: "",
      },
      createTime: [],
      chgTime: [],
      typeList: [],
      statusList: [],
      dataList: [],
      dataListLoading: false,
      dialogShow: false,
      columnList: [
        { label: this.$t("pop.themeTitle"), prop: "title" },
        { label: this.$t("pop.popType"), prop: "recommendTypeDesc" },
        { label: this.$t("pop.creatorTitle"), prop: "creatByDesc" },
        { label: this.$t("pop.createTime"), prop: "createDateString" },
        { label: this.$t("pop.editorTitle"), prop: "publishedByDesc" },
        { label: this.$t("pop.publishTime"), prop: "recommendDateString" },
        { label: this.$t("pop.status"), prop: "statusDesc" },
      ],
    };
  },
  watch: {
    update() {
      if (this.update) {
        this.getDataList();
      }
    },
  },
  computed: {
    update() {
      return this.$route.params.update;
    },
  },
  methods: {
    initIndex(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    // 获取字典表 状态值  类型
    getTypeList() {
      this.$request.post("/sys/popsUpMsg/initIndex").then((res) => {
        if (res) {
          this.typeList = [{ value: "全部", key: "" }].concat(res.recommendTypes);
          this.statusList = res.statusMetaVO;
        }
      });
    },
    getDataList() {
      this.dataListLoading = false;
      let createTime = this.createTime || [];
      let chgTime = this.chgTime || [];
      this.$request
        .post("/sys/popsUpMsg/listPopUpsMsg", {
          pageSize: this.pageSize,
          pageNo: this.pageNum,
          createDateStartString: createTime[0] || "",
          createDateEndString: createTime[1] || "",
          chngDateStartString: chgTime[0] || "",
          chngDateEndString: chgTime[1] || "",
          ...this.dataForm,
        })
        .then((res) => {
          if (res) {
            this.dataListLoading = false;
            this.total = res.totalCount;
            this.dataList = res.data || [];
          }
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    pageSizeChangeHandle(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.getDataList();
    },
    pageCurrentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    searchList() {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDataList();
    },
    resetList() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.createTime = [];
      this.chgTime = [];
      Object.keys(this.dataForm).forEach((item) => {
        this.dataForm[item] = "";
      });
      this.getDataList();
    },
    // 操作
    viewDetail(val) {
      this.$router.push({
        name: "sys-communicationPop-popManageDetail",
        query: {
          recommendId: val.recommendId,
        },
      });
      this.$eventHub.$emit("popManageDetail", "");
    },
    updatePop(val) {
      this.$router.push({
        name: "sys-communicationPop-popManageEdit",
        query: {
          edit: 0,
          recommendId: val.recommendId,
        },
      });
      this.$eventHub.$emit("popManageEdit", "");
    },
    addPop() {
      this.$router.push({
        name: "sys-communicationPop-popManageEdit",
        query: {
          edit: 1,
        },
      });
      this.$eventHub.$emit("popManageEdit", "");
    },
    delPop(val) {
      this.$confirm(this.$t("pop.confirmDel"), this.$t("prompt.title"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      }).then(() => {
        let params = {
          recommendId: val.recommendId,
        };
        this.$request.post("/sys/popsUpMsg/delete", params).then((res) => {
          if (res) {
            if (res.status === "success") {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getDataList();
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          }
        });
      });
    },
    downPop(val) {
      this.$confirm(this.$t("pop.confirmDown"), this.$t("prompt.title"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning",
      }).then(() => {
        let params = {
          recommendId: val.recommendId,
          status: 9,
          currentUserCode: JSON.parse(sessionStorage.getItem("v1user_data")).userCode,
        };
        this.$request.post("/sys/popsUpMsg/updatePopUpsStatus", params).then((res) => {
          if (res) {
            if (res.status === "success") {
              this.$message({
                message: "下架成功",
                type: "success",
              });
              this.getDataList();
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          }
        });
      });
    },
  },
  mounted() {
    Object.keys(this.dataForm).forEach((item) => {
      this.dataForm[item] = "";
    });
    this.createTime = [];
    this.chgTime = [];
    this.getTypeList();
    this.getDataList();
    this.$eventHub.$on("popManageList", () => {
      this.getTypeList();
      this.getDataList();
    });
  },
};
</script>
<style lang="scss" scoped>
.popup-manage-contain {
  min-height: calc(100% - 120px);
  padding: 15px;
  background-color: #ffffff;
  .popup-manage-search {
    height: 100%;
    width: 100%;
    display: flex;
    margin-bottom: 12px;
    .search-bar-lf {
      flex: 8;
      display: flex;
      flex-direction: row;
      .search-bar-form {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .search-bar-module {
          flex: 0 0 32%;
          padding-right: 5%;
          .el-date-editor {
            width: 100% !important;
          }
        }
      }
    }
    .search-bar-lr {
      flex: 1;
      vertical-align: middle;
      padding-top: 10px;
      .button-margin-b {
        margin-bottom: 7px;
      }
    }
  }
  .popup-manage-toolbar {
    height: 34px;
    margin-bottom: 12px;
    .popup-manage-add {
      width: 100px;
    }
  }
}
</style>
